export enum TimesheetModalType {
  CLOSED = 'CLOSED',
  NEW = 'NEW_TIMESHEET',
  DUPLICATE = 'DUPLICATE_TIMESHEET',
  BULK_DELETE = 'BULK_DELETE',
}
